import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class QuestionnairesDataProvider {
	constructor(private http: HttpClient) {}

	sendQuestionnaireEmail(data, isNew: boolean): Observable<any> {
		const url = isNew
			? '/protected/rest/job/questionnaire/save'
			: '/protected/rest/job/questionnaire/send';
		const { sendMessageData, storedFiles, uploadedFiles } = data;

		const formData: FormData = new FormData();

		for (const key in sendMessageData) {
			if (key !== 'attachmentsData') {
				formData.append(key, sendMessageData[key]);
			}
		}

		for (const key in storedFiles) {
			formData.append(`storedAttachments[${key}]`, storedFiles[key].id);
		}

		for (const key in uploadedFiles) {
			formData.append(`attachments[${key}]`, uploadedFiles[key]);
		}

		return this.http.post(url, formData);
	}

	getQuestionnarie(jobId: number, questId: number): Observable<any> {
		const url = `/protected/rest/jobs/${jobId}/questionnaire/${questId}/get/`;
		return this.http.get(url);
	}

	deleteQuestionnarie(jobId: number, questId: number): Observable<any> {
		const url = `/protected/rest/jobs/questionnaires/delete/${jobId}/${questId}/`;
		return this.http.post(url, {});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/services/questionnarie/questionnaires.data.service.ts